<template>
    <div>
      <HeaderContent title="Imigration Report" />
      <ActionContent
        :cta="false"
        :filter-modal="false"
        ctaText="Add Check Out"
        @action="modal = !modal"
        @showFilter="modalFilter = !modalFilter"
        v-model:start-date="startDate"
        v-model:end-date="endDate"
        v-model:search="search"
        @search-query="handleSearch"
        :show-export="true"
        @export="handleExport"
      />
      <CheckOutStatistics title="Foreign Guests Statistic" :data="statistics" />
      <!-- <CheckOutForm :modal="modal" @update:modal="modal = $event" /> -->
      <!-- <CheckOutFilter
        :modalFilter="modalFilter"
        @update:modalFilter="modalFilter = $event"
      /> -->
      <!-- <ModalConfirm v-model="modalConfirm" handle-action="setCheckout">
        <template #text>Are you sure to checkout this guest ?</template>
      </ModalConfirm> -->

      <CheckoutDetail
        title="Guest Detail"
        :uuid="reservationUuid"
        :data="checkout"
        v-model="modalDetail"
        @update:modal="modalDetail = $event"
      >
      </CheckoutDetail>
  
      <CheckOutDataTable
        :data="checkouts"
        :header="headers"
        :currentPage="currentPage"
        :custom-actions="customActions"
      />
  
      <!-- <DataPriview
        id="guestInfoModal"
        :selectedGuest="selectedGuest"
        :reservationDetails="reservationDetails"
        :extraCharges="extraCharges"
      /> -->
  
      <CheckOutFilter
        :modalFilter="modalFilter"
        @update:modalFilter="modalFilter = $event"
      />
  
      <ToastResponse
        v-model="toastResponse.toast"
        :text="toastResponse.text"
        :success="toastResponse.success"
      />
    </div>
  </template>
  
  <script>
  import { ref, inject, onMounted, watch, } from "vue";
  import HeaderContent from "@/components/HeaderContent.vue";
  import ActionContent from "@/components/ActionContent.vue";
//   import CheckOutForm from "./CheckoutForm.vue";
//   import CheckOutFilter from "./CheckoutFilter.vue";
// import ModalConfirm from "@/components/ModalConfirm.vue";
// import CheckOutConfirm from "@/components/ModalDialog.vue";
  import CheckOutStatistics from "@/components/StatisticData.vue";
  import CheckOutDataTable from "@/components/DataTable.vue";
  import CheckoutDetail from "./GuestCheckoutDetail.vue";
//   import iconWill from "../../../../public/icons/visit.svg";
//   import iconPremature from "../../../../public/icons/master-plan.svg";
//   import iconLate from "../../../../public/icons/overview.svg";
  import iconGuest from "../../../../public/icons/people-roof.svg";
// import iconCheckIn from "../../../../public/icons/street-view.svg";
// import iconCheckOut from "../../../../public/icons/door-open.svg";
// import DataPriview from "@/components/DataPriview.vue";
  import { formatIDR } from "@/utils/currency";
  import { dateFormatter } from "@/utils/dateFormatter";
  import { countDays } from "@/utils/dateCalculation";
//   import PaymentForm from "@/components/Payment/PaymentForm.vue";
  import ToastResponse from "@/components/ToastResponse.vue";
  import { getFormattedDate } from "@/composable/getDateTimeFormatter";
  import logo from "../../../../public/img/hotel-deliriver.png";
  // import { useRouter } from "vue-router";
  
  export default {
    components: {
      HeaderContent,
      ActionContent,
      CheckOutStatistics,
      CheckOutDataTable,
      // ModalConfirm,
      // DataPriview,
    //   PaymentForm,
    //   CheckOutFilter,
    //   CheckOutForm,
      CheckoutDetail,
      ToastResponse,
    },
    setup() {
      // const router = useRouter();

      const repositories = inject("repositories");
      const checkinRepository = repositories ? repositories.checkin : null;
      const modal = ref(false);
      const modalFilter = ref(false);
      const modalConfirm = ref(false);
      const modalCheckOut = ref(false);
      const modalDetail = ref(false);
      const modalUuid = ref("");
      const selectedGuest = ref(null);
      const reservationDetails = ref(null);
      const extraCharges = ref([]);
      const isLoading = ref(false);
      const currentPage = ref(1);
  
      const reservationUuid = ref(null);
      const actionType = ref("checkout");
      const checkouts = ref([]);
      const checkout = ref({});
  
      const statistics = ref([]);
  
      const data = ref([]);
  
      const toastResponse = ref({
        toast: false,
        text: "",
        success: false,
      });
  
      const headers = ref([
        {
          key: "reservation.guest.alias",
          label: "Alias",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",

        },
        {
          key: "reservation.guest.fullname",
          label: "Guest Name",
          sortable: true,
          thClass: "text-left",
        },
        {
          key: "reservation.guest.nationality",
          label: "Country",
          sortable: true,
          thClass: "text-left",

        },
        {
          key: "reservation.guest.identity_number",
          label: "Passport Number",
          sortable: true,
          thClass: "text-left",
        },
        {
          key: "check_in_date",
          label: "CheckIn",
          sortable: true,
          formatter: (value) => getFormattedDate(value),
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "check_out_date",
          label: "CheckOut",
          sortable: true,
          formatter: (value) => getFormattedDate(value),
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "reservation.days",
          label: "Duration",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ]);
  
      const customActions = ref([
        {
          label: "Guest Detail",
          variant: "secondary",
          icon: "fas fa-info-circle",
          action: async (item) => {
            console.log(item);
  
            checkout.value = item;
            showDetailModal(item);
          },
        },
      ]);
  
      const date = new Date();
      const getStartDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-01`;
      const getCurrentDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  
      const startDate = ref(getStartDate);
      const endDate = ref(getCurrentDate);
  
      const search = ref("");
      const filterStatus = ref({
        status: null,
      });

      const getAll = async (
        start = null,
        end = null,
        status = null,
        searchQuery = ""
      ) => {
        const params = {};
        if (start) params.start = start;
        if (end) params.end = end;
        if (status && status !== "All") params.status = status;
        if (searchQuery) params.search = searchQuery;
  
        const res = await checkinRepository.getListCheckout(params);
  
        // checkouts.value = res.data.data;
        // 🔹 Filter hanya tamu luar Indonesia
        checkouts.value = (res.data.data || []).filter(
            item => item.reservation?.guest?.nationality !== "Indonesia"
        );
        
        const checkoutStatistics = res.data.statistics;
        statistics.value = [
          {
            label: "Total",
            key: "Guest",
            value: checkoutStatistics.checkout,
            color: "primary",
            icon: iconGuest,
          },
          // {
          //   label: "Total",
          //   key: "InHouse",
          //   value: checkoutStatistics?.late_checkout,
          //   color: "primary",
          //   icon: iconCheckIn,
          // },
          // {
          //   label: "Total",
          //   key: "Check-Out",
          //   value: checkoutStatistics.checkout,
          //   color: "warning",
          //   icon: iconCheckOut,
          // },
        ];
      };
  
      const showDetailModal = (data) => {
        modalDetail.value = true;
        reservationUuid.value = data.reservation.uuid;
        console.log("data reservasi", reservationUuid.value);
      };
  
      // const handleAction = (actionType) => {
      //   if (actionType.type === "checkout") {
      //     setCheckout();
      //   }
      // };
  
      const handleFilter = (filterData) => {
        filterStatus.value = filterData;
        getAll(startDate.value, endDate.value);
      };
  
      const handleSearch = (query) => {
        search.value = query;
        getAll(startDate.value, endDate.value, filterStatus.value.status, query);
      };

      const handleExport = () => {
          // router.push({
          //     name: "imigration-report-print",
          //     query: {
          //     start_date: startDate.value,
          //     end_date: endDate.value,
          //     },
          // });

          const query = new URLSearchParams({
            start_date: startDate.value,
            end_date: endDate.value,
          }).toString();

          window.open(`/imigration-report/print?${query}`, "_blank");
      };
  
      watch([startDate, endDate, filterStatus], () => {
        getAll(
          startDate.value,
          endDate.value,
          filterStatus.value.status,
          search.value
        );
      });
  
      // const setCheckout = async () => {
      //   try {
      //     await checkinRepository
      //       .checkOut(reservationUuid.value, checkout.value)
      //       .then(() => {
      //         getAll();
      //         handlePrint();
      //         modalCheckOut.value = false;
  
      //         toastResponse.value = {
      //           toast: true,
      //           success: true,
      //           text:
      //             checkout.value.response?.message ||
      //             "Guest checked out successfully",
      //         };
      //       });
      //   } catch (e) {
      //     toastResponse.value = {
      //       toast: true,
      //       success: false,
      //       text: e.response?.data?.error || "Something went wrong!",
      //     };
      //     console.log(e);
      //   }
      // };
  
      // function handlePrint() {
      //   nextTick(() => {
      //     const printContents = document.getElementById("printArea").innerHTML;
      //     //const printWindow = window.open("", "", "width=80,height=auto");
  
      //     const now = new Date();
      //     const pad = (num) => String(num).padStart(2, "0");
      //     const formattedDate = `${now.getFullYear()}-${pad(
      //       now.getMonth() + 1
      //     )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
      //       now.getMinutes()
      //     )}-${pad(now.getSeconds())}`;
      //     const filename = `RECEIPT-deli-river-hotel-${formattedDate}`;
  
      //     // Penambahan buat iframe tersembunyi
      //     const iframe = document.createElement("iframe");
      //     iframe.style.position = "fixed";
      //     iframe.style.right = "0";
      //     iframe.style.bottom = "0";
      //     iframe.style.width = "0";
      //     iframe.style.height = "0";
      //     iframe.style.border = "0";
      //     iframe.setAttribute(
      //       "sandbox",
      //       "allow-modals allow-same-origin allow-scripts"
      //     );
      //     document.body.appendChild(iframe);
  
      //     const doc = iframe.contentDocument || iframe.contentWindow.document;
          
      //     doc.open();
      //     doc.write(`
      //       <!DOCTYPE html>
      //       <html>
      //         <head>
      //           <title>${filename}</title>
      //           <meta name="viewport" content="width=device-width,initial-scale=1.0">
      //           <style>
      //           @media print {
                  
      //             @page {
      //               size: 80mm auto;    
      //             }
      //             body {
      //               font-family: "Consolas", monospace;
      //               font-weight: bold;
      //               font-size: 14px;
      //               margin: 10px;
      //               padding: 0;
      //             }
      //             h2 {
      //               font-size: 10px;
      //               margin: 0;
      //             }
      //             h3 {
      //               margin: 0;
      //             }
      //             h4 {
      //               margin: 0;
      //             }
      //             p {
      //               margin: 3px 0px;
      //             }
      //             .billing-detail {
      //               margin-top: -5px;
      //             }
      //             hr {
      //               margin-top: -5px;
      //             }
      //             tbody {
      //               margin: 0px;
      //             }
      //         }
      //           </style>
      //         </head>
      //         <body>
      //           ${printContents}
      //         </body>
      //       </html>
      //     `);
      //     doc.close();
  
      //     // Tunggu iframe selesai load sebelum print
      //     iframe.onload = () => {
      //       iframe.contentWindow.focus();
      //       iframe.contentWindow.print();
  
      //       // Bersihkan iframe setelah print
      //       setTimeout(() => {
      //         document.body.removeChild(iframe);
      //       }, 1000);
      //     };
          
      //   });
      // }
  
      onMounted(() => {
        getAll();
      });
  
      return {
        data,
        headers,
        modal,
        checkout,
        checkouts,
        modalConfirm,
        modalCheckOut,
        modalFilter,
        actionType,
        // handleAction,
        handleFilter,
        handleSearch,
        startDate,
        endDate,
        getStartDate,
        getCurrentDate,
        search,
        filterStatus,
        formatIDR,
        dateFormatter,
        countDays,
        getFormattedDate,
        customActions,
        statistics,
        checkinRepository,
        getAll,
        // setCheckout,
        modalUuid,
        reservationUuid,
        selectedGuest,
        reservationDetails,
        extraCharges,
        isLoading,
        currentPage,
        modalDetail,
        toastResponse,
        logo,
        handleExport,
      };
    },
  };
  </script>
  <style scoped>
  .bg-primary {
    background-color: #0d6efd !important;
  }
  
  .border-bottom {
    border-bottom: 1px solid #e9ecef !important;
  }
  
  .text-start {
    text-align: left !important;
  }
  
  .fs-4 {
    font-size: 1.5rem;
  }
  
  ul {
    padding-left: 0;
  }
  
  li span:first-child {
    min-width: 100px;
    flex-shrink: 0;
  }
  
  .billing li span:first-child {
    min-width: 160px;
    flex-shrink: 0;
    font-weight: bold;
  }
  
  .billing li span:nth-child(2) {
    width: 10px;
    text-align: left;
    flex-shrink: 0;
    font-weight: bold;
  }
  
  .billing li span:last-child {
    flex: 1;
    font-weight: bold;
    word-wrap: break-word;
  }
  
  /* Style untuk extra charges */
  .extra-charges {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }
  
  .extra-charge-item {
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #007bff;
  }
  
  .payments {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }
  
  .payment-item {
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #00f974;
  }
  
  /* style untuk print */
  @media print {
    body * {
      visibility: hidden;
    }
    #printArea,
    #printArea * {
      visibility: visible;
    }
    #printArea {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
    #printArea .situs {
      padding: 30px;
    }
    button {
      display: none !important;
    }
  
    .navbar,
    .footer,
    .btn {
      display: none;
    }
    .print-only {
      display: block !important;
    }
    .screen-only {
      display: none !important;
    }
  }
  
  /* Elemen hanya layar vs hanya print */
  .print-only {
    display: none;
  }
  .screen-only {
    display: block;
  }
  .situs {
    padding: 20px;
    margin: 20px;
    color: red;
  }
  </style>
  